import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GetSession } from '../../EnvConfig/env_config';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { autoCompleteDelay } from '../../config';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBox, DateBox, FormButton, InputBox, SelectInputBox, base64ToBlob } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const PickupRunsheetReport = () => {
    const inputrefs = useRef([]);
    const dispatch = useDispatch([]);
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const Branchcode = GetSession('cookies', 'branchCode');
    const bcode = Branchcode.split(" : ")[0]

    const [formData, setFormData] = useState({
        runsheetDateFrom: formattedDate,
        runsheetDateTo: formattedDate1,
        pickupType: '',
        runsheetNo: '',
        driver: '',
        vendor: '',
    });
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const getPickupRunsheetReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Report/RunsheetReport', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/PickupRunsheetPrint', { RunsheetNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");

        // window.open(`/PDFViewer/#${result.documentPdfBase64}`, '_blank');
    }
    const handleClear = () => {
        setFormData({
            runsheetDateFrom: formattedDate,
            runsheetDateTo: formattedDate1,
            pickupType: '',
            runsheetNo: '',
            driver: '',
            vendor: '',
        });
        getPickupRunsheetReportData()
        inputrefs.current['txtRunSheetDateFrom'].focus()
    }

    const handleChange1 = (event, value) => {
        getPickupRunsheetReportData(value);
    };
    useEffect(() => {
        getPickupRunsheetReportData()
    }, [sortConfig])
    useEffect(() => {

        document.title = 'Pickup Runsheet Report'
        inputrefs.current['txtRunSheetDateFrom'].focus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Pickup Runsheet Report')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Date From"
                                placeholder="Date From"
                                id='txtRunSheetDateFrom'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRunSheetDateTo'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.runsheetDateFrom === '' ? '' : new Date(formData.runsheetDateFrom)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'runsheetDateFrom')}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Date To"
                                placeholder="Date To"
                                id='txtRunSheetDateTo'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAssignPickupBy'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.runsheetDateTo === '' ? '' : new Date(formData.runsheetDateTo)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'runsheetDateTo')}
                            />
                            <SelectInputBox
                                label='Assign Pickup By'
                                inputrefs={inputrefs}
                                id='txtAssignPickupBy'
                                value={formData.pickupType}
                                onChange={(e) => {
                                    setFormData({ ...formData, pickupType: e.target.value, driver: '', vendor: '' })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        if (formData.pickupType === 'Driver') {
                                            inputrefs.current['txtDriver'].focus()
                                        }
                                        else if (formData.pickupType === 'Vendor') {
                                            inputrefs.current['txtVendor'].focus()
                                        }
                                        else if (formData.pickupType === '') {
                                            inputrefs.current['txtRunsheetNo'].focus()
                                        }
                                    }
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                <option value='Driver'>{FindTranslatedKey('Driver')}</option>
                                <option value='Vendor'> {FindTranslatedKey('Vendor')}</option>

                            </SelectInputBox>
                            {formData.pickupType === 'Driver' ? <>
                                <AutoCompleteBox
                                    label='Driver'
                                    placeholder='Driver'
                                    inputValue={formData.driver}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetDriver');
                                            setFormData({ ...formData, driver: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtDriver'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtRunsheetNo'].focus()
                                        };
                                    }}

                                />

                            </> : <>{formData.pickupType === 'Vendor' ? <>

                                <AutoCompleteBox
                                    label='Vendor'
                                    placeholder='Vendor'
                                    inputrefs={inputrefs}
                                    id='txtVendor'
                                    value={formData.vendor}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtRunsheetNo'].focus() };
                                    }}
                                    inputValue={formData.vendor ? formData.vendor : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetVendor');
                                            setFormData({ ...formData, vendor: newInputValue })
                                        }}
                                    maxLength='50'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}

                                />

                            </> : <></>}</>}
                            <InputBox
                                id="txtRunsheetNo"
                                PlaceHolderText="Runsheet No."
                                autoComplete="off"
                                maxLength='30'
                                required={false}
                                label='Runsheet No.'
                                value={formData.runsheetNo}
                                onChange={(e) => setFormData({ ...formData, runsheetNo: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                            />
                           
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getPickupRunsheetReportData}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/Report/RunsheetReport`, formData, 'Pickup Runsheet Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                PageName={'PickupRunsheetReport'}
                loading={isLoading}
                Filter={false}
                tableData={tableData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handlePrint={handlePrint}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default PickupRunsheetReport;